import { useState } from 'react'
import { Autocomplete, Box, Chip, TextField } from '@mui/material';

const CODE_PATTERN = /^[A-Z]{3}$/;

export interface IDestinationCodesInputProps {
    value : string[];
    onChange : (value : string[]) => void;
    label? : string;
    autoFocus? : boolean;
    size? : 'small' | 'medium';
    tagsMaxHeight? : number;
}

function DestinationCodesInput(props : IDestinationCodesInputProps) {
    const { value, onChange, label = 'Destinations', autoFocus, size = 'small', tagsMaxHeight } = props;
    const [inputValue, setInputValue] = useState('');

    const normalize = (codes : (string | undefined)[]) => {
        const result : string[] = [];

        codes.forEach(code => {
            const upper = (code ?? '').trim().toUpperCase();

            if(CODE_PATTERN.test(upper) && result.indexOf(upper) === -1)
                result.push(upper);
        });

        return result;
    }

    const commitInput = () => {
        if(inputValue !== '')
            onChange(normalize([...value, inputValue]));

        setInputValue('');
    }

    return (
        <Autocomplete
            multiple
            freeSolo
            fullWidth
            size={size}
            options={[]}
            value={value}
            inputValue={inputValue}
            onInputChange={(e, newInputValue, reason) => {
                if(reason === 'input')
                    setInputValue(newInputValue.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3));
            }}
            onChange={(e, newValue) => {
                onChange(normalize(newValue as string[]));
                setInputValue('');
            }}
            onBlur={commitInput}
            renderTags={(tagValue, getTagProps) => {
                const chips = tagValue.map((option, index) => {
                    const { key, ...tagProps } = getTagProps({ index });
                    return <Chip key={key} label={option} size={size} {...tagProps} />;
                });

                if(!tagsMaxHeight)
                    return chips;

                return (
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, width: '100%', flexBasis: '100%', maxHeight: tagsMaxHeight, overflowY: 'auto', py: 0.5 }}>
                        {chips}
                    </Box>
                );
            }}
            renderInput={(params) => (
                <TextField
                    {...params}
                    autoFocus={autoFocus}
                    label={label}
                    placeholder={value.length === 0 ? 'e.g. LHR' : ''}
                />
            )}
        />
    )
}

export default DestinationCodesInput;
